export const MAIN_INVESTMENT_DASHBOARD = 'MAIN_INVESTMENT_DASHBOARD';
export const CLIENT_ONBOARDING_DASHBOARD = 'CLIENT_ONBOARDING_DASHBOARD';

export interface DashboardView {
  selectedDashboard: string;
}

export interface DashboardSettings {
  enableMainInvestmentDashboard: boolean;
  enableClientOnboardingDashboard: boolean;
}

export interface ClientSettingsModel {
  accountId: string;
  enableMainInvestmentDashboard: boolean;
  enableClientOnboardingDashboard: boolean;
  enableClientContactDocumentTab: boolean;
  enableEmployeeDocumentTab: boolean;
}

export const getDefaultClientSettings = (accountId: string) => {
  return  {
    accountId,
    enableMainInvestmentDashboard: true,
    enableClientOnboardingDashboard: false,
    enableClientContactDocumentTab: true,
    enableEmployeeDocumentTab: true,
  } as ClientSettingsModel;
};
